<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      :title="title"
      :innerHeight="120"
      :innerScroll="false"
      :qLoading="confirmLoading"
      width="600px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-form :model="form" size="small" :inline="true" :rules="rules" ref="ruleForm" label-width="100px" v-loading="loading">
        <div class="tips">仅支持对临时SKU编码进行修改</div>
        <el-form-item label="SKU编码" prop="skuCode">
          <el-autocomplete v-if="isRemake"
            class="form-input"
            v-model="form.skuCode"
            :fetch-suggestions="querySkuList"
            @select="handleSelect"
            @focus="onSkuCodeFocus"
          ></el-autocomplete>
          <el-input v-else v-model.trim="form.skuCode" @blur="handleSkuCodeModify" />
        </el-form-item>
        <el-form-item label="商品定位" prop="goodsLocation">
          <el-select v-model="form.goodsLocation">
            <el-option :label="item.optionValue" :value="item.id" v-for="item in locationOpt" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风格" prop="style">
          <el-select v-model="form.style">
            <el-option :label="item.optionValue" :value="item.id" v-for="item in styleList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有样" prop="sampleFlag">
          <el-select v-model="form.sampleFlag">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    skuCode: String|Number,
    spuId: String|Number,
    spuType: String|Number
  },
  computed: {
    title() {
      return this.skuCode ? '修改SKU' : '新增SKU';
    },
    // 是否翻拍
    isRemake() {
      return +this.spuType === 2;
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 业务
      locationOpt: [],
      styleList: [],
      form: {
        dataId: '',
        spuId: '',
        skuCode: '',
        goodsLocation: '',
        style: '',
        sampleFlag: ''
      },
      rules: {
        skuCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      loading: false,
      isSelect: '',
      skuList: [],
      confirmLoading: false,
      oldSkuCode: ''
    }
  },
  created() {
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.confirmLoading = true;
      this.$refs['ruleForm'].validate(valid => {
        if(!valid) {
          this.confirmLoading = false;
          return
        };
        const params = {
          data: [
              {
                ...this.form,
              spuId: this.spuId,
              isSelect: this.isSelect,
              oldSkuCode: this.oldSkuCode
              }
            ] 
        }
        this.$q.newProduct.updateSku(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: `${this.skuCode ? '修改' : '新增'}SKU成功`,
              });
              this.updateVal();
              this.$emit('success', {
                skuCode: this.form.skuCode,
                skuId: this.form.dataId
              });
            }
          })
          .finally(() => {
            this.confirmLoading = false;
          });
        });
    },
    async init() {
      this.dialogVisible = this.visible;
      await this.get_goodsAttrLocationSelect();
      await this.getOptionType();
      if (this.skuCode) {
        this.getSkuInfo();
      }
    },
    getSkuInfo() {
      const params = {
        params: {
          skuCode: this.skuCode,
          spuId: this.spuId
        }
      };
      this.loading = true;
      this.$q.newProduct.getSkuRelatedProduts(params)
          .then(({data}) => {
            if (data) {
              this.oldSkuCode = data.skuCode
              assignValue(this.form, data, '');
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      return this.$q.goods.goodsAttrLocationSelect().then(res => {
        this.locationOpt = res.data;
      }).catch(console.log);
    },
    // 获取风格下拉选项
    getOptionType() {
      return this.$q.goods.goodsQueryOptionType().then(res => {
        this.styleList = res.data.styleList;
      }).catch(console.log);
    },
    querySkuList(queryString, cb) {
      this.$q.newProduct.querySku({
          params: {
            skuCode: queryString
          }
        })
        .then(({data}) => {
          let results = queryString 
            ? data.filter(item => item.skuCode.toLowerCase().includes(queryString.toLowerCase()))
            : data;
          results = results.map(item => ({
            ...item,
            value: item.skuCode
          }));
          // 调用 callback 返回建议列表的数据
          cb(results);
        });
    },
    handleSkuCodeModify() {
      this.isSelect = '否';
    },
    handleSelect(item) {
      this.isSelect = '是';
      this.form.skuCode = item.value;
      // this.$refs.ruleForm.validateField('skuCode');
    },
    onSkuCodeFocus() {
      this.isSelect = '否';
    }
  }
}
</script>

<style lang="stylus" scoped>
.tips{
  color: red;
  padding-bottom: 10px;
}

</style>
